import React, { useEffect, useState } from 'react';
import {
  makeStyles,
  TextField,
  InputAdornment,
  Typography,
  Fade,
} from '@material-ui/core';
import FileCopyIcon from '@material-ui/icons/FileCopy';

const useStyles = makeStyles(() => ({
  root: {
    padding: '2rem',
    width: '60%',
  },
  textBox: {
    border: '2px solid #ededed !important',
    overflow: 'hidden',
    padding: '.5rem',
    backgroundColor: '#fff',
    borderRadius: '1rem',
  },
  MuiInputBase: {
    root: {
      direction: 'ltr ',
    },
  },
  MuiInputAdornment: {
    root: {
      transform: 'rotate(180deg)',
    },
  },
  sendText: {
    color: '#009693',
    fontSize: '1.5rem',
    fontFamily: 'Vazir',
    marginRight: '.7rem',
  },
}));

export default function BoxICons({ link }) {
  const classes = useStyles();
  const [showText, setShowText] = useState();

  const copyToClipboardHandler = () => {
    navigator.clipboard.writeText(link);
    setShowText(true);
  };

  useEffect(() => {
    setTimeout(() => {
      setShowText(false);
    }, 3500);
  }, [showText]);

  return (
    <div className={classes.root}>
      <TextField
        dir="ltr"
        className={classes.textBox}
        fullWidth
        value={link}
        id="outlined-basic"
        variant="outlined"
        autoComplete={false}
        InputProps={{
          endAdornment: (
            <InputAdornment
              position="start"
              style={{
                cursor: 'pointer',
              }}
            >
              <FileCopyIcon
                onClick={copyToClipboardHandler}
                style={{
                  transform: 'rotate(180deg)',
                  fontSize: '2.2rem',
                  color: '#009693',
                }}
              />
            </InputAdornment>
          ),
        }}
      />
      <Fade in={showText} timeout={1000}>
        <Typography
          variant="caption"
          style={{
            color: '#009693',
            fontFamily: 'Vazir-Bold',
            padding: '1rem',
          }}
        >
          کپی شد
        </Typography>
      </Fade>
    </div>
  );
}
